import styled from "styled-components";
import { primaryColor, primaryColorHover } from "../../../../config/constants";

export const BoxWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
export const Box = styled.div`
  width: 100%;
  max-width: 440px;
  border-radius: 6px;
  background-color: #fff;
  overflow: hidden;
`;
export const BoxRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 18px 20px;
  border-bottom: 1px solid #ededed;
`;
export const RowLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #222;
`;
export const RowValue = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #222;
  white-space: nowrap;
`;
export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 18px 20px;
`;
export const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
  background-color: ${primaryColor};
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
`;
export const ExportIcon = styled.img`
  width: 16px;
  height: 16px;
`;
